<template>
  <div
    id="discount"
  >
    <portal to="discount-banner">
      <template v-if="isOnboardingRedesign">
        <b-card
          v-if="show"
          v-show="loaded"
          class="px-4 py-3"
          :class="isOnboardingRedesign
            ? 'tw-bg-[#ECE8F5] tw-text-[#312849] !tw-relative tw-border-none tw-mb-0'
            : 'bg-primary text-secondary'"
          no-body
        >
          <div class="tw-flex tw-items-center tw-gap-4 tw-max-w-[800px] tw-mx-auto">
            <div class="tw-relative tw-flex tw-items-center tw-justify-center">
              <svg
                class="tw-w-[66px]"
                width="80"
                height="80"
                viewBox="0 0 67 67"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="33.4062"
                  cy="33.707"
                  r="31.0771"
                  fill="#312849"
                  stroke="white"
                  stroke-width="3.34162"
                />
                <g clip-path="url(#clip0_164_3985)">
                  <path
                    d="M33.3441 28.6905C34.972 27.6733 32.8639 25.0914 31.0986 23.8111C29.3222 22.5463 26.2614 21.3553 25.7613 23.2181L23.2303 32.6801C22.9517 33.7287 24.0155 34.5166 24.9315 33.9436L33.3441 28.6905ZM29.0859 26.6038C27.231 25.2768 26.3373 23.8607 26.7107 23.3492C27.0764 22.8322 28.6981 23.2353 30.5484 24.5767C32.4166 25.9015 33.3037 27.3188 32.9358 27.8225C32.5646 28.3473 30.9429 27.9441 29.0859 26.6038Z"
                    fill="white"
                  />
                  <path
                    d="M26.9087 18.4371C27.3074 18.3719 27.5864 17.9918 27.52 17.5865C27.4547 17.1878 27.0691 16.9166 26.6704 16.9819C26.2584 17.0493 25.9928 17.4272 26.0581 17.8259C26.1244 18.2312 26.4967 18.5046 26.9087 18.4371ZM27.9893 19.5361C27.9025 19.2979 27.7093 19.118 27.4502 19.1604C27.2054 19.2073 26.9866 19.4547 27.0833 19.7118C27.6381 21.2244 27.9014 22.8325 27.8624 24.4696C27.845 24.7386 28.1368 24.8955 28.3771 24.863C28.6296 24.8216 28.7631 24.5951 28.7694 24.3416C28.8162 22.6691 28.5572 21.0875 27.9893 19.5361ZM31.2036 18.9143C31.9013 18.8 32.3614 18.1515 32.2483 17.4605C32.1329 16.7561 31.4922 16.3015 30.7945 16.4157C30.0967 16.53 29.6344 17.1652 29.7498 17.8696C29.8629 18.5607 30.5058 19.0285 31.2036 18.9143ZM30.2838 21.2142C30.6094 21.1609 30.825 20.8527 30.7717 20.5271C30.7195 20.2081 30.4168 19.9847 30.0912 20.038C29.7722 20.0903 29.5433 20.4007 29.5955 20.7196C29.6489 21.0453 29.9648 21.2664 30.2838 21.2142ZM36.4997 17.2556C36.8187 17.2034 37.0354 16.9018 36.9821 16.5761C36.9288 16.2505 36.6261 16.0272 36.3071 16.0794C35.9815 16.1327 35.7659 16.441 35.8192 16.7666C35.8725 17.0922 36.1741 17.3089 36.4997 17.2556ZM34.65 18.002L33.6109 19.4481C33.4609 19.6569 33.5154 19.9481 33.7175 20.0993C33.933 20.2482 34.2264 20.207 34.3754 19.9916L35.4156 18.5521C35.5656 18.3433 35.51 18.0454 35.3079 17.8942C35.1002 17.7509 34.8001 17.7932 34.65 18.002ZM32.5895 20.8776L29.7544 24.8148C29.6032 25.017 29.6599 25.3216 29.8621 25.4727C30.0698 25.6161 30.3765 25.5727 30.5199 25.365L33.3474 21.4222C33.4852 21.2222 33.4428 20.9221 33.2407 20.771C33.0386 20.6198 32.7351 20.6832 32.5895 20.8776ZM38.0804 23.1172C38.4858 23.0508 38.7581 22.6719 38.6906 22.2599C38.6253 21.8612 38.2464 21.5889 37.8411 21.6553C37.429 21.7227 37.1634 22.1006 37.2287 22.4993C37.2961 22.9113 37.6684 23.1846 38.0804 23.1172ZM35.2677 23.8575C35.8591 23.7607 36.2558 23.2249 36.1589 22.6335C36.0632 22.0487 35.5142 21.6542 34.9227 21.751C34.338 21.8468 33.9567 22.3937 34.0525 22.9784C34.1493 23.5698 34.6829 23.9533 35.2677 23.8575ZM38.385 26.5608C38.7904 26.4944 39.0637 26.1221 38.9963 25.7101C38.9299 25.3048 38.551 25.0325 38.1457 25.0989C37.7403 25.1653 37.468 25.5442 37.5344 25.9495C37.6018 26.3615 37.9797 26.6272 38.385 26.5608ZM36.1059 25.351C34.4477 25.3087 32.8728 25.5665 31.2948 26.1387C31.0643 26.2311 30.8855 26.431 30.9325 26.6758C30.9727 26.9216 31.2145 27.1481 31.4716 27.0514C33.0108 26.4924 34.6112 26.2235 36.2283 26.2657C36.4896 26.2775 36.6619 25.9969 36.6272 25.7433C36.5914 25.483 36.3527 25.3584 36.1059 25.351Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_164_3985">
                    <rect
                      width="17.0563"
                      height="16.881"
                      fill="white"
                      transform="translate(20.7031 17.9609) rotate(-9.29938)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <p
                class="tw-w-[3rem] tw-mb-0 tw-text-[0.8rem] tw-rotate-[-20deg] tw-text-white tw-absolute tw-bottom-[25px] tw-left-[14px]"
                :class="{'tw-font-bold': !isSafari}"
              >
                <span v-if="couponData.percent_off">{{ couponData.percent_off }}%</span>
                <span v-else-if="!couponData.percent_off && couponData.metadata?.credit_amount">${{ couponData.metadata.credit_amount }}</span>
                Off
              </p>
            </div>
            <div>
              <p class="tw-mb-0 tw-text-lg md:tw-text-2xl tw-tracking-tight tw-leading-tight">
                Exclusive savings on your treatment plan!
              </p>
              <p class="tw-mb-0 tw-mt-2 tw-text-sm md:tw-text-lg">
                *Discount {{ couponid }} applied at checkout.
              </p>
            </div>
          </div>
        </b-card>
      </template>
      <template v-else>
        <b-card
          v-if="show"
          v-show="loaded"
          class="px-4 py-3 bg-primary text-secondary tw-mb-0"
          no-body
        >
          <b-row align-h="between">
            <b-col
              cols="12"
              sm="6"
              class="text-center text-sm-left"
            >
              Active Discount: <br>
              <span class="heading text-secondary">
                {{ couponid }}
              </span>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="text-center text-sm-right"
            >
              <span v-if="couponData.percent_off">
                Enjoy {{ couponData.percent_off }}% off
              </span>
              <span v-if="couponData.applies_to">
                {{ discountedProduct.name }} for
              </span>
              <span v-if="couponData.duration == 'once'">
                your first treatment plan!
              </span>
              <br>
              <span class="text-small">Discount applied at checkout</span>
            </b-col>
          </b-row>
        </b-card>
      </template>
    </portal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { OnboardingService } from '@/services/onboarding.service';
import { ProductService } from '@/services/product.service';
import { isSafari, isMobileSafari } from 'mobile-device-detect';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    couponid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loaded: false,
      couponData: {},
      discountedProduct: {},
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    isSafari() {
      return isSafari || isMobileSafari || /webview|wv|ip((?!.*Safari)|(?=.*like Safari))/i.test(window.navigator.userAgent);
    },
  },
  watch: {
    couponid: {
      async handler(id) {
        this.loaded = false;
        if (id) {
          const { data } = await OnboardingService.checkCoupon(id);
          this.couponData = data;
          if (this.couponData.applies_to) {
            const getProduct = await ProductService.getProduct(
              this.couponData.applies_to.products[0]
            );
            this.discountedProduct = getProduct.data;
          }
        }
    
        this.loaded = true;
      },
      immediate: true,
    }
  },
};
</script>

<style>
.text-small {
  font-size: 0.8rem !important;
}

</style>
